var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { PropertySearch } from './../models/index';
import { Router } from '@angular/router';
import * as Raven from 'raven-js';
var PropertyService = /** @class */ (function (_super) {
    __extends(PropertyService, _super);
    function PropertyService(apiCallService, router) {
        var _this = _super.call(this) || this;
        _this.apiCallService = apiCallService;
        _this.router = router;
        return _this;
    }
    PropertyService.prototype.getProperties = function (propertySearch, sort, page) {
        var path = '/new_properties';
        if (propertySearch) {
            path += this.apiCallService.getSeachUrlParams(propertySearch, sort, page);
        }
        return this.apiCallService.get(path);
    };
    PropertyService.prototype.decodeUrlParams = function (params, advancedLimits, oldPropertySearch) {
        Raven.captureBreadcrumb({
            message: 'PropertyService.decodeUrlParams',
            category: 'search',
            data: {
                params: params,
                advanced_limits: advancedLimits
            }
        });
        var propertySearch = null;
        if (oldPropertySearch) {
            propertySearch = oldPropertySearch;
        }
        else {
            propertySearch = new PropertySearch();
        }
        for (var field in params) {
            if (params.hasOwnProperty(field) && params[field] && params[field].length) {
                if (Array.isArray(propertySearch[field])) {
                    if (Array.isArray(params[field])) {
                        if (params[field].every(function (e, i, a) { return isNaN(+e); })) {
                            propertySearch[field] = params[field];
                        }
                        else {
                            propertySearch[field] = params[field].map(function (param) { return +param; });
                        }
                    }
                    else {
                        if (+params[field]) {
                            propertySearch[field] = [+params[field]];
                        }
                        else {
                            propertySearch[field] = [params[field]];
                        }
                    }
                }
                else if (typeof propertySearch[field] === 'boolean') {
                    propertySearch[field] = params[field] === 'true';
                }
                else if (!isNaN(params[field]) && field !== 'number') {
                    propertySearch[field] = +params[field];
                }
                else {
                    propertySearch[field] = params[field];
                }
            }
        }
        if (advancedLimits) {
            for (var field in advancedLimits) {
                if (advancedLimits.hasOwnProperty(field) && propertySearch[field] === null) {
                    propertySearch[field] = advancedLimits[field];
                }
            }
        }
        return propertySearch;
    };
    PropertyService.prototype.getPromoProperties = function () {
        return this.apiCallService.get('/new_properties/promo');
    };
    PropertyService.prototype.getProperty = function (friendly_id) {
        return this.apiCallService.get('/properties/' + friendly_id + '?token=secrettokenpreview');
    };
    PropertyService.prototype.generateBreadcrums = function (property) {
        return [];
    };
    PropertyService.prototype.resolve = function (route) {
        var _this = this;
        var promise;
        var page = route.data['page'] ? route.data['page'] : 1;
        if (route.params['friendly_id'] === undefined) {
            if (route.data['property_search']) {
                promise = this.getProperties(route.data['property_search'], undefined, page);
            }
            else if (route.data['property_type']) {
                var propertySearch = this.decodeUrlParams(route.queryParams);
                propertySearch.property_type = route.data['property_type'];
                promise = this.getProperties(propertySearch, undefined, page);
            }
            else {
                promise = this.getProperties(new PropertySearch(), undefined, 1);
            }
        }
        else {
            promise = this.getProperty(route.params['friendly_id'])
                .catch(function (error) {
                _this.router.navigate(['/apartamente']);
                throw error;
            });
        }
        return promise;
    };
    PropertyService.prototype.generateCharacteristicsString = function (property) {
        var str = new Array();
        if (property.property_type === 'apartamente' || property.property_type === 'casevile') {
            if (property.has_basement) {
                str.push('S');
            }
            if (property.has_semi_basement) {
                str.push('D');
            }
            str.push('P');
            if (property.floor_count)
                str.push(property.floor_count.toString() + 'E');
            if (property.has_loft) {
                str.push('M');
            }
        }
        return str.join(' + ');
    };
    return PropertyService;
}(BaseApiService));
export { PropertyService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/property.service.ts.pre-build-optimizer.js